// utils/min-max.ts

/**
 * Returns the min and max values from a number array.
 * Returns [Infinity, -Infinity] for empty arrays to ensure
 * math operations (like Math.min) don't result in NaN or undefined.
 */
export function minMax(values: number[]): [min: number, max: number] {
  if (values.length === 0) {
    return [Infinity, -Infinity];
  }

  let min = values[0];
  let max = values[0];

  for (let i = 1; i < values.length; i++) {
    const val = values[i];

    if (val < min) {
      min = val;
    }

    if (val > max) {
      max = val;
    }
  }

  return [min, max];
}
